export default "__VITE_ASSET__BKo2tfcU__"